/**
 * Smart Call Assistant - Landing Page JavaScript
 * Handles: Sticky Navbar, Mobile Nav, Screenshot Slider, Lightbox, FAQ Accordion
 */
(function () {
    'use strict';

    // --- Sticky Navbar ---
    var navbar = document.getElementById('sca-navbar');
    if (navbar) {
        window.addEventListener('scroll', function () {
            if (window.scrollY > 40) {
                navbar.classList.add('sca-navbar--scrolled');
            } else {
                navbar.classList.remove('sca-navbar--scrolled');
            }
        });
    }

    // --- Mobile Nav Toggle ---
    var navToggle = document.getElementById('sca-nav-toggle');
    var navMobile = document.getElementById('sca-nav-mobile');
    if (navToggle && navMobile) {
        navToggle.addEventListener('click', function () {
            navMobile.classList.toggle('sca-navbar__mobile--open');
            var isOpen = navMobile.classList.contains('sca-navbar__mobile--open');
            var icon = navToggle.querySelector('i');
            icon.className = isOpen ? 'fa-solid fa-xmark' : 'fa-solid fa-bars';
            navToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });

        // Close mobile nav on link click
        var mobileLinks = navMobile.querySelectorAll('.sca-navbar__mobile-link');
        mobileLinks.forEach(function (link) {
            link.addEventListener('click', function () {
                navMobile.classList.remove('sca-navbar__mobile--open');
                var icon = navToggle.querySelector('i');
                icon.className = 'fa-solid fa-bars';
            });
        });
    }

    // --- Screenshot Slider ---
    var sliderTrack = document.getElementById('sca-slider-track');
    var sliderDots = document.getElementById('sca-slider-dots');
    var currentSlide = 0;
    var autoSlideTimer = null;

    function getSlideCount() {
        if (!sliderTrack) return 0;
        return sliderTrack.children.length;
    }

    function getMaxSlide() {
        return Math.max(0, getSlideCount() - 1);
    }

    function updateSlider() {
        if (!sliderTrack) return;
        var slides = sliderTrack.children;
        if (!slides.length) return;

        // Move track by percentage (each slide is 100% width)
        sliderTrack.style.transform = 'translateX(-' + (currentSlide * 100) + '%)';

        // Update dots
        if (sliderDots) {
            var dots = sliderDots.querySelectorAll('.sca-slider__dot');
            dots.forEach(function (dot, i) {
                dot.classList.toggle('sca-slider__dot--active', i === currentSlide);
            });
        }
    }

    function goToSlide(index) {
        var max = getMaxSlide();
        currentSlide = Math.max(0, Math.min(index, max));
        updateSlider();
        resetAutoSlide();
    }

    function nextSlide() {
        var max = getMaxSlide();
        currentSlide = currentSlide >= max ? 0 : currentSlide + 1;
        updateSlider();
    }

    function resetAutoSlide() {
        if (autoSlideTimer) clearInterval(autoSlideTimer);
        autoSlideTimer = setInterval(nextSlide, 5000);
    }

    // Init slider dots
    if (sliderDots) {
        var dots = sliderDots.querySelectorAll('.sca-slider__dot');
        dots.forEach(function (dot) {
            dot.addEventListener('click', function () {
                var index = parseInt(dot.getAttribute('data-index'), 10);
                goToSlide(index);
            });
        });
    }

    // Pause auto-slide on hover
    if (sliderTrack) {
        sliderTrack.parentElement.addEventListener('mouseenter', function () {
            if (autoSlideTimer) clearInterval(autoSlideTimer);
        });
        sliderTrack.parentElement.addEventListener('mouseleave', function () {
            resetAutoSlide();
        });
    }

    // Start auto-slide
    if (sliderTrack) {
        resetAutoSlide();
        window.addEventListener('resize', function () {
            updateSlider();
        });
    }

    // --- Lightbox ---
    var lightbox = document.getElementById('sca-lightbox');
    var lightboxImg = document.getElementById('sca-lightbox-img');
    var lightboxClose = document.getElementById('sca-lightbox-close');

    function openLightbox(src, alt) {
        if (!lightbox || !lightboxImg) return;
        lightboxImg.src = src;
        lightboxImg.alt = alt || '';
        lightbox.classList.add('sca-lightbox--open');
        document.body.style.overflow = 'hidden';
    }

    function closeLightbox() {
        if (!lightbox) return;
        lightbox.classList.remove('sca-lightbox--open');
        document.body.style.overflow = '';
        if (lightboxImg) lightboxImg.src = '';
    }

    // Click on phone frame to open lightbox (supports img or placeholder)
    var phoneFrames = document.querySelectorAll('.sca-phone-frame');
    phoneFrames.forEach(function (frame) {
        frame.addEventListener('click', function () {
            // Support both: frame is <img> itself, or frame wraps an <img>
            var img = frame.tagName === 'IMG' ? frame : frame.querySelector('img');
            if (img && img.src) {
                openLightbox(img.src, img.alt);
            }
        });
    });

    if (lightboxClose) {
        lightboxClose.addEventListener('click', closeLightbox);
    }

    if (lightbox) {
        lightbox.addEventListener('click', function (e) {
            if (e.target === lightbox || e.target === lightbox.querySelector('.sca-lightbox__content')) {
                closeLightbox();
            }
        });
    }

    // ESC to close lightbox
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeLightbox();
    });

    // --- FAQ Accordion ---
    var faqList = document.getElementById('sca-faq-list');
    if (faqList) {
        var faqItems = faqList.querySelectorAll('.sca-faq__item');
        faqItems.forEach(function (item) {
            var question = item.querySelector('.sca-faq__question');
            if (!question) return;

            question.addEventListener('click', function () {
                var isOpen = item.classList.contains('sca-faq__item--open');

                // Close all other items
                faqItems.forEach(function (other) {
                    other.classList.remove('sca-faq__item--open');
                    var btn = other.querySelector('.sca-faq__question');
                    if (btn) btn.setAttribute('aria-expanded', 'false');
                });

                // Toggle current
                if (!isOpen) {
                    item.classList.add('sca-faq__item--open');
                    question.setAttribute('aria-expanded', 'true');
                }
            });
        });
    }

    // --- Smooth scroll for anchor links ---
    document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
        anchor.addEventListener('click', function (e) {
            var targetId = this.getAttribute('href');
            if (targetId === '#') return;
            var target = document.querySelector(targetId);
            if (target) {
                e.preventDefault();
                var navHeight = navbar ? navbar.offsetHeight : 0;
                var top = target.getBoundingClientRect().top + window.scrollY - navHeight;
                window.scrollTo({ top: top, behavior: 'smooth' });
            }
        });
    });
})();
